
import React from "react";
import {
  DialogHeader as UIDialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";

interface DialogHeaderProps {
  title: string;
  onClose?: () => void;
}

export const DialogHeader = ({ title, onClose }: DialogHeaderProps) => {
  return (
    <UIDialogHeader>
      <DialogTitle>{title}</DialogTitle>
      <DialogDescription>
        {title.toLowerCase().includes('edit') ? 
          'Update the strategy details below.' : 
          'Fill in the strategy details below.'}
      </DialogDescription>
    </UIDialogHeader>
  );
};

export default DialogHeader;
